/*-----------------------------------------------------------------
- Subscription trans
-----------------------------------------------------------------*/
export default {

    subscription: 'Subscription',

};
